export default __webpack_public_path__ + "static/a2z-logo-white-ef0e9fb28f80f73c24d9f2c5d2138050.svg";